import React from "react"
import SEO from "../components/seo"
import AccordianSection from "../components/AccordianSection"
import Map from "../components/Map"
import HeaderSection from "../components/HeaderSection"
import CeoSection from "../components/CeoSection"
import PortfolioCompaniesSection from "../components/PortfolioCompaniesSection"
import ImpactAcrossPortfolioSection from "../components/ImpactAcrossPortfolioSection"
import FooterSection from "../components/FooterSection"
import TestimonialSection from "../components/TestimonialSection"
import CaseStudiesSection from "../components/CaseStudiesSection"
import OurImpactApproachSection from "../components/OurImpactApproachSection"

const Home = () => {
  return (
    <>
      <main style={{ backgroundColor: "#FFFFFF" }}>
        <SEO
          title="ABC World Asia | Impact Report 2020"
          lang="en"
          description="This inaugural report is our first step into the world of impact investing. Through this report, we share our learnings and experience over the past year. We are keen to grow our collective work through insights from the ground."
        />
        <HeaderSection />
        <CeoSection />
        <PortfolioCompaniesSection />

        <section style={{ marginTop: "40px", zIndex: 3, position: "relative" }}>
          <Map />
        </section>

        <ImpactAcrossPortfolioSection />

        <OurImpactApproachSection />
        <AccordianSection />

        <CaseStudiesSection />
        <TestimonialSection />
      </main>
      <FooterSection />
    </>
  )
}

export default Home
